import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'insancaSaniye',
    standalone: true,
})
export class insancaSaniye implements PipeTransform {
    constructor() {

    }

    transform(seconds: any) {
        var levels: any = [
            [Math.floor(seconds / 31536000), 'y'],
            [Math.floor((seconds % 31536000) / 86400), 'g'],
            [Math.floor(((seconds % 31536000) % 86400) / 3600), 's'],
            [Math.floor((((seconds % 31536000) % 86400) % 3600) / 60), 'dk'],
            [((((seconds % 31536000) % 86400) % 3600) % 60).toFixed(4), 'sn'],
        ];
        var returntext = '';

        for (var i = 0, max = levels.length; i < max; i++) {
            if (levels[i][0] === 0) continue;
            // returntext += ' ' + levels[i][0] + '' + (levels[i][0] === 1 ? levels[i][1].substr(0, levels[i][1].length - 1) : levels[i][1]);
            returntext += ' ' + levels[i][0] + '' + levels[i][1];
        };
        // if (returntext.startsWith(" 1 ")) returntext = [returntext.slice(0, 1), "1s ", returntext.slice(1)].join('');
        return returntext.trim();
    }
}
